<!-- Footer Start -->
<footer class="layout-footer">
  <span>Copyright © {{ fullyear }} Syscom Distribution LLC. All rights reserved.</span>
</footer>
<!-- Footer End -->
